export default __webpack_public_path__ + "95d21f4a3ed5f528b50d8ef9db5a0533.svg";